import React from 'react';
import { Button, Flex, Dropdown } from 'antd';
import DeleteAllButton from './DeleteAllButton';

/**
 * A component to display the Create Patterns button with cost estimation
 */
const CreatePatternsButton = React.memo(({ 
    selectedPatternIds, 
    projectionCostDetails, 
    isFormSubmitting, 
    isEstimatingCost, 
    isSaving, 
    isAssignmentTooBigForProjection,
    handleContinueLater,
    onMoveSelectedPatterns,
    availableComponents,
    onDeleteSuccess,
    // new props
    onCreateSelectedPatterns,
    onCreateAllPatterns,
    onCreateCurrentComponentPatterns,
    activeComponentId,
    currentComponentPatternsCount = 0,
}) => {
    // Determine the button text based on selection state
    const buttonTextAll = 'Create All';
    const buttonTextSelected = `Create Selected ${projectionCostDetails}`;

    // Determine if the button should be disabled
    const isButtonDisabled = isAssignmentTooBigForProjection || 
        (selectedPatternIds.length === 0 && projectionCostDetails !== '');

    return (
        <Flex 
            gap={8} 
            wrap='wrap'
        >
            <Button 
                onClick={handleContinueLater}
            >
                Continue Later
            </Button>
            
            {selectedPatternIds.length > 0 && onMoveSelectedPatterns && availableComponents?.length > 0 && (
                <Dropdown
                    menu={{
                        items: availableComponents.map(component => ({
                            key: component.id,
                            label: component.name,
                            onClick: () => onMoveSelectedPatterns(component.id)
                        }))
                    }}
                    disabled={selectedPatternIds.length === 0}
                >
                    <Button>
                        Move Selected ({selectedPatternIds.length}) to
                    </Button>
                </Dropdown>
            )}
            
            <DeleteAllButton
                selectedPatternIds={selectedPatternIds}
                isFormSubmitting={isFormSubmitting}
                isSaving={isSaving}
                onDeleteSuccess={onDeleteSuccess}
            />
            {selectedPatternIds.length > 0 && (
                <Button
                    type='default'
                    loading={isFormSubmitting || isEstimatingCost || isSaving}
                    disabled={isAssignmentTooBigForProjection}
                    onClick={onCreateSelectedPatterns}
                >
                    {buttonTextSelected}
                </Button>
            )}
            <Button
                type='default'
                loading={isFormSubmitting || isEstimatingCost || isSaving}
                disabled={isButtonDisabled}
                onClick={onCreateAllPatterns}
            >
                {buttonTextAll}
            </Button>
            <Button
                type='primary'
                loading={isFormSubmitting || isEstimatingCost || isSaving}
                disabled={!activeComponentId || currentComponentPatternsCount === 0}
                onClick={onCreateCurrentComponentPatterns}
            >
                Create in Current Component ({currentComponentPatternsCount})
            </Button>
        </Flex>
    );
});

export default CreatePatternsButton; 